import { useContext } from 'react'

import { AuthContext } from '@/context/auth-context'
import { useAppSelector } from '@/store/store-hooks'
import type { RootState } from '@/store/store'
import { selectAgentConversationFromId } from '@/agent/conversations/store/selectors'

/**
 * Whether the current user owns (created) this conversation.
 *
 * A non-owner is a collaborator viewing someone else's chat; they get read-only chat options
 * (Download only, no Delete/Rename/Move-to-matter). A missing current user or a not-yet-loaded
 * conversation is treated as owned so we never over-restrict on a load race; the backend still
 * enforces the real permission.
 */
export function useIsConversationOwner(conversationId: string | undefined): boolean {
  const { user } = useContext(AuthContext)
  const conversation = useAppSelector((state: RootState) => selectAgentConversationFromId(state, { conversationId }))

  if (!user?.uid) return true
  if (!conversation) return true
  return conversation.user_id === user.uid
}
